<ion-row>
  <ion-col class="text ion-no-padding">
    {{ displayedText }}
  </ion-col>
</ion-row>
